// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-loader {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  z-index: 100;
}

.modal-content-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  background: none;
}

.loader {
  width: 40px;
  aspect-ratio: 1;
  display: grid;
  border: 4px solid rgba(0, 0, 0, 0);
  border-radius: 50%;
  border-color: #307af2 rgba(0, 0, 0, 0);
  animation: l16 0.75s infinite linear;
}

.loader::before,
.loader::after {
  content: "";
  grid-area: 1/1;
  margin: 2px;
  border: inherit;
  border-radius: 50%;
}

.loader::before {
  border-color: #f03355 rgba(0, 0, 0, 0);
  animation: inherit;
  animation-duration: 0.5s;
  animation-direction: reverse;
}

.loader::after {
  margin: 8px;
}

@keyframes l16 {
  100% {
    transform: rotate(1turn);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,0BAAA;EACA,kCAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,sCAAA;EACA,oCAAA;AACF;;AACA;;EAEE,WAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAEF;;AAAA;EACE,sCAAA;EACA,kBAAA;EACA,wBAAA;EACA,4BAAA;AAGF;;AADA;EACE,WAAA;AAIF;;AAFA;EACE;IAAK,wBAAA;EAML;AACF","sourcesContent":[".modal-loader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.3);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  z-index: 100;\n}\n\n.modal-content-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: fit-content;\n  background: none;\n}\n\n.loader {\n  width: 40px;\n  aspect-ratio: 1;\n  display: grid;\n  border: 4px solid #0000;\n  border-radius: 50%;\n  border-color: #307af2 #0000;\n  animation: l16 0.75s infinite linear;\n}\n.loader::before,\n.loader::after {    \n  content: \"\";\n  grid-area: 1/1;\n  margin: 2px;\n  border: inherit;\n  border-radius: 50%;\n}\n.loader::before {\n  border-color: #f03355 #0000;\n  animation: inherit; \n  animation-duration: .5s;\n  animation-direction: reverse;\n}\n.loader::after {\n  margin: 8px;\n}\n@keyframes l16 { \n  100%{transform: rotate(1turn)}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
